import React, { FC } from 'react';
import { ForgeButton, ForgeIcon, ForgeIconButton, ForgeToolbar } from '@tylertech/forge-react';
import { I18n } from 'common/visualizations';
import { isValidScheduledReport } from '../../validators';
import { ScheduleSendValues } from '../../types/scheduleSend';

const scope = 'shared.components.schedule_send_report.modal';

interface FooterProps {
  onDismiss: () => void;
  onPreview: () => void;
  onSaveConfiguration: () => void;
  onUpdate: () => void;
  prevAction: string;
  scheduleSendValues: ScheduleSendValues;
}

const Footer: FC<FooterProps> = ({
  onDismiss,
  onPreview,
  onSaveConfiguration,
  onUpdate,
  prevAction,
  scheduleSendValues
}) => {
  return (
    <ForgeToolbar inverted={true} className="footer-toolbar">
      {isValidScheduledReport(scheduleSendValues) && (
        <div slot="start">
          <ForgeIconButton dense={true} density={'medium'} onclick={onPreview} data-testid="preview-button">
            <ForgeIcon name="eye" aria-hidden="false" external external-type="extended"></ForgeIcon>
          </ForgeIconButton>
        </div>
      )}
      <div slot="end">
        <ForgeButton variant="outlined" id="cancel-button" onClick={onDismiss}>
          {I18n.t('cancel', { scope })}
        </ForgeButton>
        {prevAction != 'edit' ? (
          <ForgeButton variant="raised" id="save-button" onClick={onSaveConfiguration}>
            <ForgeIcon name="send_clock" aria-hidden="false" external external-type="extended"></ForgeIcon>
            {I18n.t('title', { scope })}
          </ForgeButton>
        ) : (
          <ForgeButton variant="raised" id="update-button" onClick={onUpdate}>
            {I18n.t('save', { scope })}
          </ForgeButton>
        )}
      </div>
    </ForgeToolbar>
  );
};

export default Footer;
